/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityPasswordInputIcon64Regular = forwardRef('SecurityPasswordInputIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M18.5 32a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" }),
        React.createElement("path", { d: "M26.5 35a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
        React.createElement("path", { d: "M40.5 32a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" }),
        React.createElement("path", { d: "M48.5 35a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 22.5a8.5 8.5 0 0 1 8.5-8.5h41a8.5 8.5 0 0 1 8.5 8.5v19a8.5 8.5 0 0 1-8.5 8.5h-41A8.5 8.5 0 0 1 3 41.5v-19Zm8.5-5.5A5.5 5.5 0 0 0 6 22.5v19a5.5 5.5 0 0 0 5.5 5.5h41a5.5 5.5 0 0 0 5.5-5.5v-19a5.5 5.5 0 0 0-5.5-5.5h-41Z" })));
});
